import { render, staticRenderFns } from "./PrazoPagamentoManageModal.vue?vue&type=template&id=2aef410e&scoped=true"
import script from "./PrazoPagamentoManageModal.vue?vue&type=script&lang=js"
export * from "./PrazoPagamentoManageModal.vue?vue&type=script&lang=js"
import style0 from "./PrazoPagamentoManageModal.vue?vue&type=style&index=0&id=2aef410e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aef410e",
  null
  
)

export default component.exports